module.exports = __webpack_public_path__ + "img/map.dfc96944.svg";